import { render, staticRenderFns } from "./TbFilaURA.vue?vue&type=template&id=19c30a2e&scoped=true"
import script from "./TbFilaURA.vue?vue&type=script&lang=js"
export * from "./TbFilaURA.vue?vue&type=script&lang=js"
import style0 from "./TbFilaURA.vue?vue&type=style&index=0&id=19c30a2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c30a2e",
  null
  
)

export default component.exports